import { Card, Form } from "react-bootstrap";
import { useQuery, useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useState } from "react";

import { GET_DEPOSITS } from "../../graphql/queries/deposit";
import { UPDATE_DEPOSIT_SETTING } from "../../graphql/mutations/deposit";
import { showErrorToast } from "../../components/common/CustomErrorMessage";
import SubmitButton from "../../components/common/SubmitButton";
import CustomFormGroupRow from "../../components/form/CustomFormGroupRow";
import CustomSwitch from "../../components/form/CustomSwitch";

const DepositPage = () => {
  const [formData, setFormData] = useState({
    short: {
      percent: 0,
      duration: 0,
      min: 0,
      max: 0,
      enabled: false,
    },
    medium: {
      percent: 0,
      duration: 0,
      min: 0,
      max: 0,
      enabled: false,
    },
    long: {
      percent: 0,
      duration: 0,
      min: 0,
      max: 0,
      enabled: false,
    },
  });
  const [walletId, setWalletId] = useState(null);

  const { loading: walletLoading } = useQuery(GET_DEPOSITS, {
    fetchPolicy: "network-only",
    onCompleted(data) {
      if (data.deposits) {
        const deposits = data.deposits;
        setWalletId(deposits.id);
        setFormData({
          short: {
            percent: deposits.short?.percent || 0,
            duration: deposits.short?.duration || 0,
            min: deposits.short?.min || 0,
            max: deposits.short?.max || 0,
            enabled: deposits.short?.enabled || false,
          },
          medium: {
            percent: deposits.medium?.percent || 0,
            duration: deposits.medium?.duration || 0,
            min: deposits.medium?.min || 0,
            max: deposits.medium?.max || 0,
            enabled: deposits.medium?.enabled || false,
          },
          long: {
            percent: deposits.long?.percent || 0,
            duration: deposits.long?.duration || 0,
            min: deposits.long?.min || 0,
            max: deposits.long?.max || 0,
            enabled: deposits.long?.enabled || false,
          },
        });
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const [updateDepositSetting, { loading: updateLoading }] = useMutation(
    UPDATE_DEPOSIT_SETTING,
    {
      refetchQueries: [{ query: GET_DEPOSITS }],
      onCompleted: (data) => {
        if (data.updateDepositSetting) {
          toast.success(`ອັບເດດການຝາກສຳເລັດແລ້ວ`, {
            position: "top-center",
            autoClose: 3000,
            className: "lao",
          });
        }
      },
      onError(err) {
        showErrorToast(err.message);
      },
    }
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [plan, field] = name.split(".");
    setFormData((prev) => ({
      ...prev,
      [plan]: {
        ...prev[plan],
        [field]: field === "enabled" ? value === "true" : Number(value),
      },
    }));
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    const [plan, field] = name.split(".");
    setFormData((prev) => ({
      ...prev,
      [plan]: {
        ...prev[plan],
        [field]: checked,
      },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!walletId) {
      toast.error("ບໍ່ພົບຂໍ້ມູນກະເປົາເງິນດິຈິຕອນ", {
        position: "top-center",
        className: "lao",
      });
      return;
    }
    updateDepositSetting({
      variables: {
        id: walletId,
        input: formData,
      },
    });
  };

  return (
    <div className="lao">
      <Card>
        <Card.Header>
          <Card.Title>
            <h3 className="p-1">ຈັດການເງິນຝາກ</h3>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          {walletLoading ? (
            <div className="text-center">ກຳລັງໂຫຼດ...</div>
          ) : (
            <Form className="notolao" onSubmit={handleSubmit}>
              {/* Short Plan */}
              <h5 className="mb-3 lao">Short Plan</h5>
              <CustomFormGroupRow
                label="Percent (%)"
                name="short.percent"
                onChange={handleChange}
                type="number"
                value={formData.short.percent}
                placeholder="Enter percent"
              />
              <CustomFormGroupRow
                label="ຈຳນວນມື້ (days)"
                name="short.duration"
                onChange={handleChange}
                type="number"
                value={formData.short.duration}
                placeholder="Enter duration"
              />
              <CustomFormGroupRow
                label="ຝາກຂັ້ນຕ່ຳ (Min Amount)"
                name="short.min"
                onChange={handleChange}
                type="number"
                value={formData.short.min}
                placeholder="Enter minimum"
              />
              <CustomFormGroupRow
                label="ຝາກຂັ້ນສູງ (Max Amount)"
                name="short.max"
                onChange={handleChange}
                type="number"
                value={formData.short.max}
                placeholder="Enter maximum"
              />
              <CustomSwitch
                label="ເປີດໃຊ້"
                name="short.enabled"
                onChange={handleSwitchChange}
                value={formData.short.enabled}
              />

              <hr className="my-4" />

              {/* Medium Plan */}
              <h5 className="mb-3 lao">Medium Plan</h5>
              <CustomFormGroupRow
                label="Percent (%)"
                name="medium.percent"
                onChange={handleChange}
                type="number"
                value={formData.medium.percent}
                placeholder="Enter percent"
              />
              <CustomFormGroupRow
                label="ຈຳນວນມື້ (days)"
                name="medium.duration"
                onChange={handleChange}
                type="number"
                value={formData.medium.duration}
                placeholder="Enter duration"
              />
              <CustomFormGroupRow
                label="ຝາກຂັ້ນຕ່ຳ (Min Amount)"
                name="medium.min"
                onChange={handleChange}
                type="number"
                value={formData.medium.min}
                placeholder="Enter minimum"
              />
              <CustomFormGroupRow
                label="ຝາກຂັ້ນສູງ (Max Amount)"
                name="medium.max"
                onChange={handleChange}
                type="number"
                value={formData.medium.max}
                placeholder="Enter maximum"
              />
              <CustomSwitch
                label="ເປີດໃຊ້"
                name="medium.enabled"
                onChange={handleSwitchChange}
                value={formData.medium.enabled}
              />

              <hr className="my-4" />

              {/* Long Plan */}
              <h5 className="mb-3 lao">Long Plan</h5>
              <CustomFormGroupRow
                label="Percent (%)"
                name="long.percent"
                onChange={handleChange}
                type="number"
                value={formData.long.percent}
                placeholder="Enter percent"
              />
              <CustomFormGroupRow
                label="ຈຳນວນມື້ (days)"
                name="long.duration"
                onChange={handleChange}
                type="number"
                value={formData.long.duration}
                placeholder="Enter duration"
              />
              <CustomFormGroupRow
                label="ຝາກຂັ້ນຕ່ຳ (Min Amount)"
                name="long.min"
                onChange={handleChange}
                type="number"
                value={formData.long.min}
                placeholder="Enter minimum"
              />
              <CustomFormGroupRow
                label="ຝາກຂັ້ນສູງ (Max Amount)"
                name="long.max"
                onChange={handleChange}
                type="number"
                value={formData.long.max}
                placeholder="Enter maximum"
              />
              <CustomSwitch
                label="ເປີດໃຊ້"
                name="long.enabled"
                onChange={handleSwitchChange}
                value={formData.long.enabled}
              />

              <div className="text-center mt-4">
                <div style={{ display: "inline-block" }}>
                  <SubmitButton loading={updateLoading} />
                </div>
              </div>
            </Form>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default DepositPage;
